
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import  themen  from 'theme/styles/styled-colors';
import  * as theme  from 'react-syntax-highlighter/dist/esm/styles/hljs';
import SyntaxHighlighter from 'react-syntax-highlighter';


const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <h1 {...{
      "id": "import-api"
    }}>{`Import API`}</h1>
    <p>{`The general approach is:`}</p>
    <ul>
      <li parentName="ul">{`Consumer makes a ZIP file available for import operation. See details below for the 2 flavors of the API.`}</li>
      <li parentName="ul">{`The API if successful, will return the results of the operation.`}</li>
      <li parentName="ul">{`Error will be returned on the failure of the call.`}</li>
    </ul>
    <h3 {...{
      "id": "import-zip-file-using-post"
    }}>{`Import ZIP File Using POST`}</h3>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}><strong parentName="th">{`Title`}</strong></th>
          <th parentName="tr" {...{
            "align": null
          }}><strong parentName="th">{`Import API`}</strong></th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><em parentName="td">{`Example`}</em></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`See Examples sections below.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><em parentName="td">{`Description`}</em></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Provide the contents of the file to be imported in the request body.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><em parentName="td">{`URL`}</em></td>
          <td parentName="tr" {...{
            "align": null
          }}><em parentName="td">{`api/atlas/admin/import`}</em></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><em parentName="td">{`Method`}</em></td>
          <td parentName="tr" {...{
            "align": null
          }}><em parentName="td">{`POST`}</em></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><em parentName="td">{`URL Parameters`}</em></td>
          <td parentName="tr" {...{
            "align": null
          }}><em parentName="td">{`None`}</em></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><em parentName="td">{`Data Parameters`}</em></td>
          <td parentName="tr" {...{
            "align": null
          }}><em parentName="td">{`None`}</em></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><em parentName="td">{`Success Response`}</em></td>
          <td parentName="tr" {...{
            "align": null
          }}><em parentName="td">{`AtlasImporResult`}</em>{` is returned as JSON. See details below.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><em parentName="td">{`Error Response`}</em></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Errors that are handled within the system will be returned as `}<em parentName="td">{`AtlasBaseException`}</em>{`.`}</td>
        </tr>
      </tbody>
    </table>
    <h3 {...{
      "id": "import-zip-file-available-on-server"
    }}>{`Import ZIP File Available on Server`}</h3>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}><strong parentName="th">{`Title`}</strong></th>
          <th parentName="tr" {...{
            "align": null
          }}><strong parentName="th">{`Import API`}</strong></th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><em parentName="td">{`Example`}</em></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`See Examples sections below.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><em parentName="td">{`Description`}</em></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Provide the path of the file to be imported.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><em parentName="td">{`URL`}</em></td>
          <td parentName="tr" {...{
            "align": null
          }}><em parentName="td">{`api/atlas/admin/importfile`}</em></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><em parentName="td">{`Method`}</em></td>
          <td parentName="tr" {...{
            "align": null
          }}><em parentName="td">{`POST`}</em></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><em parentName="td">{`URL Parameters`}</em></td>
          <td parentName="tr" {...{
            "align": null
          }}><em parentName="td">{`None`}</em></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><em parentName="td">{`Data Parameters`}</em></td>
          <td parentName="tr" {...{
            "align": null
          }}><em parentName="td">{`None`}</em></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><em parentName="td">{`Success Response`}</em></td>
          <td parentName="tr" {...{
            "align": null
          }}><em parentName="td">{`AtlasImporResult`}</em>{` is returned as JSON. See details below.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><em parentName="td">{`Error Response`}</em></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Errors that are handled within the system will be returned as `}<em parentName="td">{`AtlasBaseException`}</em>{`.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><em parentName="td">{`Notes`}</em></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The file to be imported needs to be present on the server at the location specified by the `}<em parentName="td">{`FILENAME`}</em>{` parameter.`}</td>
        </tr>
      </tbody>
    </table>
    <p><strong parentName="p">{`Method Signature for Import`}</strong></p>
    <SyntaxHighlighter wrapLines={true} language="shell" style={theme.dark} mdxType="SyntaxHighlighter">
      {`@POST
@Path("/import")
@Produces("application/json; charset=UTF-8")
@Consumes("multipart/form-data")`}
    </SyntaxHighlighter>
    <p><strong parentName="p">{`Method Signature for Import File`}</strong></p>
    <SyntaxHighlighter wrapLines={true} language="shell" style={theme.dark} mdxType="SyntaxHighlighter">
      {`@POST
@Path("/importfile")
@Produces("application/json; charset=UTF-8")
@Consumes("application/json")`}
    </SyntaxHighlighter>
    <p><strong parentName="p">{`Import Options`}</strong>{`
Please see `}<a parentName="p" {...{
        "href": "#/ImportAPIOptions"
      }}>{`here`}</a>{` for the available options during import process.`}</p>
    <p><strong parentName="p">{`AtlasImportResult Response`}</strong>{`
The API will return the results of the import operation in the format defined by the `}<em parentName="p">{`AtlasImportResult`}</em>{`:`}</p>
    <ul>
      <li parentName="ul"><em parentName="li">{`AtlasImportParameters`}</em>{`: This contains a collection of name-value pair of the options that are applied during the import operation.`}</li>
      <li parentName="ul"><em parentName="li">{`Metrics`}</em>{`: Operation metrics. These include details on the number of types imported, number of entities imported, etc.`}</li>
      <li parentName="ul"><em parentName="li">{`Processed Entities`}</em>{`: Contains a list of GUIDs for the entities that were processed.`}</li>
      <li parentName="ul"><em parentName="li">{`Operation Status`}</em>{`: Overall status of the operation. Values are `}<em parentName="li">{`SUCCESS`}</em>{`, PARTIAL`}<em parentName="li">{`SUCCESS, _FAIL`}</em>{`.`}</li>
    </ul>
    <h3 {...{
      "id": "examples-using-curl-calls"
    }}>{`Examples Using CURL Calls`}</h3>
    <p>{`The call below performs Import of `}<em parentName="p">{`QuickStart`}</em>{` database using POST.`}</p>
    <SyntaxHighlighter wrapLines={true} language="shell" style={theme.dark} mdxType="SyntaxHighlighter">
      {`curl -g -X POST -u adminuser:password -H "Content-Type: multipart/form-data"
            -H "Cache-Control: no-cache"
            -F request=@importOptions.json
            -F data=@quickStartDB.zip
            "http://localhost:21000/api/atlas/admin/import"`}
    </SyntaxHighlighter>
    <p>{`The `}<em parentName="p">{`request`}</em>{` parameter is optional. If import has to be run without any options use:`}</p>
    <SyntaxHighlighter wrapLines={true} language="shell" style={theme.dark} mdxType="SyntaxHighlighter">
      {`curl -g -X POST -u adminuser:password -H "Content-Type: multipart/form-data"
            -H "Cache-Control: no-cache"
            -F data=@quickStartDB.zip
            "http://localhost:21000/api/atlas/admin/import"`}
    </SyntaxHighlighter>
    <p>{`The call below performs Import of `}<em parentName="p">{`QuickStart`}</em>{` database using a ZIP file available on the server.`}</p>
    <SyntaxHighlighter wrapLines={true} language="shell" style={theme.dark} mdxType="SyntaxHighlighter">
      {`curl -X POST -u adminuser:password -H "Cache-Control: no-cache" -d ./importOptions.json
"http://localhost:21000/api/atlas/admin/importFile" > quickStartDB-import-result.json`}
    </SyntaxHighlighter>
    <p>{`Below is the `}<em parentName="p">{`AtlasImportResult`}</em>{` JSON for an import that contains `}<em parentName="p">{`hive_db`}</em>{`.`}</p>
    <p>{`The `}<em parentName="p">{`processedEntities`}</em>{` contains the `}<em parentName="p">{`guids`}</em>{` of all the entities imported.`}</p>
    <p>{`The `}<em parentName="p">{`metrics`}</em>{` contain a breakdown of the types and entities imported along with the operation performed on them viz. `}<em parentName="p">{`created`}</em>{` or `}<em parentName="p">{`updated`}</em>{`.`}</p>
    <SyntaxHighlighter wrapLines={true} language="json" style={theme.dark} mdxType="SyntaxHighlighter">
      {`{
    "request": {
        "options": {}
    },
    "userName": "admin",
    "clientIpAddress": "10.0.2.2",
    "hostName": "10.0.2.15",
    "timeStamp": 1491285622823,
    "metrics": {
        "duration": 9143,
        "typedef:enum": 0,
        "typedef:struct": 0,
        "entity:hive_column:created": 461,
        "entity:hive_storagedesc:created": 20,
        "entity:hive_process:created": 12,
        "entity:hive_db:created": 5,
        "entity:hive_table:created": 20,
        "entity:hdfs_path:created": 2,
        "typedef:entitydef": 0,
        "typedef:classification": 3
    },
    "processedEntities": [
        "2c4aa713-030b-4fb3-98b1-1cab23d9ac81",
        "e4aa71ed-70fd-4fa7-9dfb-8250a573e293",
       ...
        "ea0f9bdb-1dfc-4e48-9848-a006129929f9",
        "b5e2cb41-3e7d-4468-84e1-d87c320e75f9"
    ],
    "operationStatus": "SUCCESS"
}`}
    </SyntaxHighlighter>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;